module.exports = __webpack_public_path__ + "static/application-ratings-a4884c3d29cfec48312181e9768f6505.png";